import React from 'react'
import { Button, Container, Image, Nav, Navbar } from 'react-bootstrap'
import { BsMoon, BsSun } from 'react-icons/bs'
import { useDispatch } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { logout } from '@store/thunk/auth.thunk'
import { AppDispatch } from '@store/store'
import { useTheme } from '@config/theme.config'
import { getLinkClasses } from '@shared/tools/style.tools'
import TaskManager from '@components/shared/taskManager.component'

const HeaderComponent = () => {
  const { theme, toggleTheme } = useTheme()
  const location = useLocation()
  const dispatch = useDispatch<AppDispatch>()

  const handleLogout = (e: React.MouseEvent) => {
    e.preventDefault()
    dispatch(logout())
  }

  const handleThemeChange = (e: any) => {
    e.preventDefault()
    toggleTheme()
  }

  return (
    <Navbar bg={'dark'} variant={'dark'} className={'pb-0'} expand="md">
      <Container>
        <Navbar.Brand href="/" className="">
          <Image
            src={'/dark_mode_small.png'}
            width="150px"
            alt="Logo"
            className="pb-2"
          />
        </Navbar.Brand>
        <Nav className="ms-4 me-auto" style={{ height: '60px' }}>
          <Link to="/" className={getLinkClasses('', theme, location.pathname)}>
            Dashboard
          </Link>
          <Link
            to="/playlist/create"
            className={getLinkClasses('/playlist*', theme, location.pathname)}
          >
            Blok vysílání
          </Link>
          <Link
            to="/archive"
            className={getLinkClasses('/archive', theme, location.pathname)}
          >
            Archiv
          </Link>
          {/*<Link*/}
          {/*  to="/settings"*/}
          {/*  className={getLinkClasses('/settings', theme, location.pathname)}*/}
          {/*>*/}
          {/*  Nastavení*/}
          {/*</Link>*/}
        </Nav>
        <TaskManager></TaskManager>
        <Nav className="align-items-center flex-row">
          <Button
            onClick={handleThemeChange}
            variant={'outline-light'}
            className="me-1"
          >
            {theme == 'dark' ? <BsSun /> : <BsMoon />}
          </Button>
          <Button onClick={(e) => handleLogout(e)} variant="danger">
            Odhlásit
          </Button>
        </Nav>
      </Container>
    </Navbar>
  )
}

export default HeaderComponent
